import { render, staticRenderFns } from "./GeneralSettings.vue?vue&type=template&id=0e9dbdf9&scoped=true&"
import script from "./GeneralSettings.vue?vue&type=script&lang=js&"
export * from "./GeneralSettings.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSettings.vue?vue&type=style&index=0&id=0e9dbdf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9dbdf9",
  null
  
)

export default component.exports